import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk } from '../../app/store';
import { Equipment } from '../../models/equipment';
import { patchEquipmentFulfilled, deleteEquipmentFulfilled, addEquipmentFulfilled } from './editEquipmentSlice';

//let queryEquipmentTimeoutId: NodeJS.Timeout | undefined;

const initialState: EquipmentState = {
  query: '',
  type: 'weapon',
  equipment: [],
  meta: '',
  admin: false,
  strn: 19
};

export interface EquipmentState {
  query: string;
  type: string;
  equipment: Equipment[];
  meta: string;
  admin: boolean;
  strn: number;
}

export const slice = createSlice({
  name: 'equipment',
  initialState,
  reducers: {
    setQuery: (state, action: PayloadAction<string>) =>{
      state.query = action.payload;
    },
    setType: (state, action: PayloadAction<string>) =>{
      state.type = action.payload;
    },
    setMeta: (state, action: PayloadAction<string>) => {
      state.meta = action.payload;
    },
    setAdmin: (state, action: PayloadAction<boolean>) => {
      state.admin = action.payload;
    },
    setStrn: (state, action: PayloadAction<number>) => {
      state.strn = action.payload;
    },
    queryEquipmentFulfilled: (state, action: PayloadAction<Equipment[]>) => {
      state.equipment = action.payload;
    },
    getEquipmentFulfilled: (state, action: PayloadAction<Equipment>) => {
      //todo
    }
  },
  extraReducers: builder => {
    builder.addCase(addEquipmentFulfilled, (state, action) => {
      state.equipment.push(action.payload);
    });

    builder.addCase(patchEquipmentFulfilled, (state, action) => {
      const i = state.equipment.findIndex(x => x.id === action.payload.id);
      if (i !== -1) {
        state.equipment[i] = action.payload;
      }
    });

    builder.addCase(deleteEquipmentFulfilled, (state, action) => {
      const i = state.equipment.findIndex(x => x.id === action.payload);
      if (i !== -1) {
        state.equipment.splice(i, 1);
      }
    });
  }
});

export const queryEquipment = (): AppThunk<Promise<Equipment[]>> => async (dispatch) => {  
  const url = 'https://wotcodeapi.azurewebsites.net/api/equipment';
  const results = await fetch(url).then(resp => resp.json()) as Equipment[];
  dispatch(slice.actions.queryEquipmentFulfilled(results));
  return results;
};

export const getEquipment = (id: number): AppThunk<Promise<Equipment | null>> => async (dispatch) => {  
  const url = `https://wotcodeapi.azurewebsites.net/api/equipment/${id}`;
  let result = await fetch(url).then(resp => resp.json());
  let equipment: Equipment | null = null;
  if (!result.status) {
    equipment = result as Equipment;
    dispatch(slice.actions.getEquipmentFulfilled(equipment));
  }
  return equipment;
};

export const addEquipment = (equipment: Equipment): AppThunk => async (dispatch) => {
  const clone = {...equipment, fields: Object.keys(equipment)};
  const url = 'https://wotcodeapi.azurewebsites.net/api/equipment?force=true&appVersion=999';
  const result = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(clone),
    headers: { 'Content-Type': 'application/json' }
  }).then(resp => resp.json());
  dispatch(addEquipmentFulfilled(result));
};

export const patchEquipment = (equipment: Equipment): AppThunk => async (dispatch) => {
  const clone = {...equipment, fields: Object.keys(equipment)};
  const url = 'https://wotcodeapi.azurewebsites.net/api/equipment?force=true&appVersion=999';
  const result = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(clone),
    headers: { 'Content-Type': 'application/json' }
  }).then(resp => resp.json());
  dispatch(patchEquipmentFulfilled(result));
};

export const deleteEquipment = (id: number): AppThunk => async (dispatch) => {
  const url = `https://wotcodeapi.azurewebsites.net/api/equipment/${id}`;
  await fetch(url, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' }
  });
  dispatch(deleteEquipmentFulfilled(id));
};

export default slice.reducer;
export const { setQuery, setType, setMeta, setAdmin, setStrn } = slice.actions;